import { upgradeVoucherErrors } from '../constants/upgrade-voucher-codes';

const domesticRoutes = ['Playa', 'Frontera', 'Local'];
const regionsNotAllowed = ['EUR', 'ASI', 'CAM'];

function getCmsErrorUpgradeVoucher(unredeemedVouchers) {
  const actionableErrors = {
    ABORT: [],
    CONTINUE: [],
    FIX: [],
    RETRY: [],
  };
  const groupByReason = unredeemedVouchers.reduce((result, item) => {
    const {
      reason = '',
    } = item;
    if (Boolean(reason)) {
      const actionableReason = upgradeVoucherErrors[reason];
      const {
        actionable,
      } = actionableReason;

      if (!result[actionable].includes(item.reason)) {
        result[actionable] = [...result[actionable], item.reason];
      }
    }
    return result;
  }, actionableErrors);

  const actionableAbort = groupByReason.ABORT;
  const actionableContinue = groupByReason.CONTINUE;
  const actionableFix = groupByReason.FIX;
  const actionableRetry = groupByReason.RETRY;
  let error = '';

  if (actionableAbort.length) {
    error = actionableAbort[0];
  } else if (!actionableAbort.length && actionableFix.length) {
    error = actionableFix[0];
  } else if (!actionableAbort.length && !actionableFix.length && actionableRetry.length) {
    error = actionableRetry[0];
  } else if (!actionableAbort.length && !actionableRetry.length && !actionableFix.length && actionableContinue.length) {
    error = actionableContinue[0];
  }
  return error;
}

function getLegRegion(legs, segment) {
  let region = null;
  for (const leg of legs._legCollection) {
    const legFound = leg.segmentsCollection.some(seg => seg.segmentCode === segment.segmentCode);
    if (legFound) {
      region = domesticRoutes.includes(leg.legRegion) ? 'DOM' : leg.legRegion;
    }
  }

  return region;
}

function getLegsRegion(legs) {
  const legsRegion = legs.map(leg => {
    return domesticRoutes.includes(leg.legRegion) ? 'DOM' : leg.legRegion;
  });
  return legsRegion;
}

function getCardInUse(card, vouchersCounter, vouchers, unlimitedVoucher) {
  const locked = card + '_INIT';
  if (card === 'AMXPLT' && unlimitedVoucher && Boolean(vouchers)) {
    return card;
  } else {
    return vouchersCounter[card] === vouchersCounter[locked] ? '' : card;
  }
}

function setUpgradeVouchersAvailable(upgrades) {
  return upgrades?.reduce((acc, cur) => {
    const code = cur.cardCode === 'AMEX' ? 'AMXPLT' : 'SEIFNT';
    const locked = code + '_INIT';
    const amount = cur.vouchers?.length || 0;

    acc = {
      ...acc,
      [code]: amount,
      [locked]: amount,
    };
    return acc;
  }, {});
}

function getUnlimitedVouchers(upgrades) {
  const amexUpgrades = upgrades.find(upgrade => upgrade.cardCode === 'AMEX');
  if (amexUpgrades?.vouchers?.length > 0) {
    const unlimitedVoucher = amexUpgrades.vouchers.find(voucher => voucher.voucherCodeNo === '11111111');
    return unlimitedVoucher ? unlimitedVoucher : null;
  }
  return null;
}

function getSegmentRegion(segment) {
  return domesticRoutes.includes(segment.segmentRegion) ? 'DOM' : segment.segmentRegion;
}

function checkRegionAllowedForAmex(segment) {
  return regionsNotAllowed.includes(segment.segmentRegion);
}

function checkLegRegion(userCobrandCards, legsArray,  cartUpsell) {
  const hasAmexSant = userCobrandCards.map(card => {
    if (card.code === 'AMXPLT' || card.code === 'SEIFNT') {
      return card?.code;
    }
  }).filter(Boolean);

  let regions = [];

  for (const leg of legsArray) {
    const {
      segmentsCollection,
    } = leg;
    const segments = segmentsCollection.map(segment => segment);

    for (const segment of segments) {
      const upSellLeg = cartUpsell.find(up => up.legCode === leg.legCode && segment.segmentCode === up.segmentCode);
      if (upSellLeg?.upgradeAvailable && upSellLeg?.upgradeBenefitCobrand) {
        const segmentRegion = getSegmentRegion(segment);
        if (!regionsNotAllowed.includes(segmentRegion) ) {
          regions = [...regions, segmentRegion];
        }
      }
    }
  }

  const hasRegionAllowedSant = regions.some(region => region === 'DOM');
  if (hasAmexSant.includes('AMXPLT') && regions?.length) {
    return true;
  } else if (hasAmexSant.includes('SEIFNT') && hasRegionAllowedSant) {
    return true;
  }
  return false;
}

export {
  checkLegRegion,
  checkRegionAllowedForAmex,
  getCardInUse,
  getCmsErrorUpgradeVoucher,
  getLegRegion,
  getLegsRegion,
  getSegmentRegion,
  getUnlimitedVouchers,
  setUpgradeVouchersAvailable,
};